import {getCurrencySymbol} from '@/helpers';

const currencySymbol = {
  methods: {
    getCurrencySymbol (currency) {
      return getCurrencySymbol (currency);
    },
  },
};

export {currencySymbol};
